import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { FieldOperationsSensorsFieldName } from './field-operations-sensors.types';

export const FIELD_OPERATIONS_SENSORS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [FieldOperationsSensorsFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.GNN_ID,
    value: 2,
    types: [FieldOperationsSensorsFieldName.ServiceLocationIds],
    hintText: SEARCH_HINTS.GNN
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.INSTALLED_BY,
    value: 3,
    types: [FieldOperationsSensorsFieldName.LastChangedBy],
    hintText: SEARCH_HINTS.InstalledBy
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SENSOR_SERIAL_NUMBER,
    value: 4,
    types: [FieldOperationsSensorsFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  }
];

export const FIELD_OPERATIONS_SENSORS_DEFAULT_SEARCH_TYPE: SearchType = FIELD_OPERATIONS_SENSORS_SEARCH_TYPES[0];
